<template>
  <!-- <div> -->
  <el-form v-if="isInit" :inline="inline" v-bind="formProps" v-on="$listeners">
    <edit-item
      v-for="(item, index) in formOptions"
      v-show="!item.hidden"
      class="form-item-box"
      :class="item.key"
      :key="index"
      ref="editItems"
      :editable="editable"
      :item="item">
      <template :slot="`${prop}`" slot-scope="scope" v-for="prop in Object.keys($scopedSlots)">
        <slot :name="`${prop}`" v-bind="scope"></slot>
      </template>
    </edit-item>
  </el-form>
  <!-- </div> -->
</template>

<script>
// editItem组件通过mixins带进来了
// import editItem from '@/components/form/edit-item'
import formValidate from './formValidate.mixin'
// import { deepCopy } from '@/utils/utils'
export default {
  name: 'EditForm',
  mixins: [formValidate],
  data () {
    return {
    }
  },
  props: {
    editable: Boolean,
    inline: {
      type: Boolean,
      default: true
    },
    formOptions: {
      type: Array,
      default: () => []
    },
    formProps: {
      type: Object,
      default: () => {
        return {
          labelWidth: '114px'
        }
      }
    }
  },
  created () {
    this.resetData()
  },
  mounted () {
  },
  watch: {
    formOptions (n) {
      this.resetData(n)
    }
  },
  methods: {
    resetData () {
      this.formOptions.forEach(el => {
        el.label = el.label || el.title
      })
    }
  },
  computed: {
  },
  components: {
    // editItem
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
// .form-item-box
  // min-width 300px
</style>
